<template>
  <date-picker month-picker
               :model-value="props.ym"
               locale="ko"
               format="yyyy-MM"
               model-type="yyyyMM"
               :enable-time-picker="false"
               :auto-apply="true"
               :clearable="props.isClear"
               :min-date="minYm"
               :max-date="maxYm"
               @update:model-value="mcal_selectYm"
               week-start="0"
               year-first
               prevent-min-max-navigation
               :disabled="props.disabled"
               :teleport="true">
  </date-picker>
</template>

<script setup>
import DatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import {defineProps, defineEmits, computed} from "vue";

import {getUtils} from "@/utils/import";
const {$cmmn} = getUtils();

const props = defineProps({
  ym: String,
  min: {
    type: String,
    default: null
  },
  max: {
    type: String,
    default: null
  },
  disabled: {
    type: Boolean,
    default: false
  },
  isClear: {
    type: Boolean,
    default: false
  },
})

const emits = defineEmits(['select']);

const minYm = computed(() => {
  if (props.min) return $cmmn.date.getYmFormat(props.min, '-');
  else {
    return '1950-01';
  }
});

const maxYm = computed(() => {
  if (props.max) return $cmmn.date.getYmFormat(props.max, '-');
  else {
    return '2099-12';
  }
});

const mcal_selectYm = (ym) => {
  emits('select', ym ?? '');
};

</script>

<style scoped>

</style>
